"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _EditableTableContext = require("./EditableTableContext");
var _ValidationTooltip = _interopRequireDefault(require("./ValidationTooltip"));
var _util = require("./../util");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["editable", "dataIndex", "children", "inputProps", "record", "inputType", "title", "isFirstEditable", "isLastEditable", "getInput", "disabled", "viewMode", "mapValuesToForm", "save", "cancel", "onInputBlur", "onInputFocus", "undoText", "index", "tooltipProps", "size", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EditableCell = function EditableCell(_ref) {
  var editable = _ref.editable,
    dataIndex = _ref.dataIndex,
    children = _ref.children,
    inputProps = _ref.inputProps,
    record = _ref.record,
    inputType = _ref.inputType,
    title = _ref.title,
    isFirstEditable = _ref.isFirstEditable,
    isLastEditable = _ref.isLastEditable,
    getInput = _ref.getInput,
    disabled = _ref.disabled,
    viewMode = _ref.viewMode,
    mapValuesToForm = _ref.mapValuesToForm,
    save = _ref.save,
    cancel = _ref.cancel,
    onInputBlur = _ref.onInputBlur,
    onInputFocus = _ref.onInputFocus,
    undoText = _ref.undoText,
    index = _ref.index,
    _ref$tooltipProps = _ref.tooltipProps,
    tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
    size = _ref.size,
    className = _ref.className,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // if cell is not editable just use normal rendering
  if (!editable) {
    return /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({}, restProps, {
      className: className
    }), children);
  }
  var _useEditableTableForm = (0, _EditableTableContext.useEditableTableForm)(),
    form = _useEditableTableForm.form,
    isRowEditing = _useEditableTableForm.isRowEditing,
    editingKey = _useEditableTableForm.editingKey,
    rowKey = _useEditableTableForm.rowKey;
  var _inputRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    init = _useState2[0],
    setInit = _useState2[1];
  var editing = isRowEditing(record);

  // if first editable focus input ob edit mode enabled

  (0, _react.useEffect)(function () {
    if (editable && isFirstEditable && editing) {
      if (!init) {
        setInit(true);
      }
    }
  }, [editable, isFirstEditable, editing]);
  (0, _react.useEffect)(function () {
    if (init) {
      if (isLastEditable) {
        form.current.setFieldsValue(mapValuesToForm(record));
      } else if (isFirstEditable && _inputRef.current && _inputRef.current.focus) {
        setTimeout(function () {
          _inputRef.current.focus();
          // fix masked input elements cursor position
          _inputRef.current.selectionStart = _inputRef.current.selectionEnd = 10000;
        }, 50);
      }
    }
  }, [init]);
  (0, _react.useEffect)(function () {
    // if last editable set form fields. this is the safest place. otherwise we should use setTimeout to delay setFields value which is still unreliable
    if (editable && isLastEditable && editing) {
      if (!init) {
        setInit(true);
      }
    }
  }, [editable, isLastEditable, editingKey, editing]);
  function undo() {
    var preparedRecord = mapValuesToForm(record);
    form.current.setFieldsValue((0, _defineProperty2.default)({}, dataIndex, preparedRecord[dataIndex]));
  }
  function renderInput() {
    var isDisabled = false;
    if (disabled) {
      if (typeof disabled === 'function') {
        isDisabled = disabled(record);
      } else {
        isDisabled = true;
      }
    }
    var isViewMode = false;
    if (viewMode) {
      if (typeof viewMode === 'function') {
        isViewMode = viewMode(record);
      } else {
        isViewMode = true;
      }
    }
    var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
    /**
     * tablo small size ise input'lar yeni xsmall size'ı kullanır,
     * değil ise mevcuttaki gibi small size'ı kullanmaya devam eder
     */
    var inputSize = size === 'small' ? 'xsmall' : 'small';
    var InputCoponent = getInput(dataIndex, record, _objectSpread({
      size: inputSize,
      inputRef: function inputRef(ref) {
        if (ref) {
          _inputRef.current = ref;
        }
      },
      ref: function ref(item) {
        if (!_inputRef.current) {
          _inputRef.current = item;
        }
      },
      name: dataIndex,
      className: "editable-cell-".concat(key, "-").concat(dataIndex, " table-input"),
      disabled: isDisabled,
      viewMode: isViewMode,
      formRef: form
    }, inputProps), inputType);
    var errors = form.current.getFieldError(dataIndex);
    return /*#__PURE__*/_react.default.createElement(_ValidationTooltip.default, (0, _extends2.default)({}, tooltipProps, {
      errors: errors,
      undo: undo,
      undoText: undoText,
      placement: index % 2 === 0 ? 'bottom' : 'top'
    }), InputCoponent);
  }
  return /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({}, restProps, {
    className: (0, _classnames.default)(className, {
      'editing-cell': editing
    })
  }), editing && form.current ? renderInput() : children);
};
var _default = exports.default = EditableCell;